import { IFormRender } from '@busybusy/webapp-react-ui';
import { bitwisePayloadDisabler } from 'components/foundation/BitwiseGroup/util/Util';
import BasicPickerFormField from 'components/foundation/form-fields/BasicPickerFormField/BasicPickerFormField';
import BitwiseGroupFormField from 'components/foundation/form-fields/BitwiseGroupFormField/BitwiseGroupFormField';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { t } from 'utils/localize';
import { defaultBitwisePayloads } from '../util/constants';

export interface IPositionsViewActivityReportFormFieldsFormType {
  viewAllActivityReport: string;
  viewMemberActivityReport: number | null;
}

export interface IPositionsViewActivityReportFormFieldsProps<T extends IPositionsViewActivityReportFormFieldsFormType> {
  form: IFormRender<T>;
}

function PositionsViewActivityReportFormFields<T extends IPositionsViewActivityReportFormFieldsFormType>({
  form,
}: IPositionsViewActivityReportFormFieldsProps<T>) {
  return (
    <>
      <HeaderText title={t('View Activity Reports')} />
      <BasicPickerFormField
        name="viewAllActivityReport"
        form={form}
        data={[
          { id: '0', name: t('Mobile Employee Report Only') },
          { id: '1', name: t('All Activity Reports') },
        ]}
      />

      {form.state.data.viewAllActivityReport === '0' && (
        <>
          <HeaderText title={`${t('View Activity Reports for')}:`} />
          <BitwiseGroupFormField
            className="mt-2"
            name={'viewMemberActivityReport'}
            payloads={bitwisePayloadDisabler(defaultBitwisePayloads, 1)}
            form={form}
          />
        </>
      )}
    </>
  );
}

export default PositionsViewActivityReportFormFields;
